import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Typography, Button, TextField, Grid, Paper } from '@mui/material';
import CreateSubscriptions from './CreateSubscriptions';
import AddSubSections from './AddSections';
import CreateSections from './CreateSections';
import CreateSpecializedFields from './CreateSpecializedFields';
import Header1 from '../Header/Header1';
import Footer2 from '../Footer/Footer2';
import AdminVerification from './AdminVerification';
import UpdateSubscription from './UpdateSubscription';
import DeleteSubscription from './DeleteSubscription';
import CreateLanguage from './CreateLanguage';
import DeleteLanguage from './DeleteLanguage';
import UpdateSections from './UpdateSections';
import DeleteSection from './DeleteSection';
import InterviewPanel from './InterviewPanel';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import AdminFaqs from './AdminFaqs';
import AdminUpdatePosts from './AdminUpdatePosts';
import ReportedPosts from './ReportedPosts';
import GeneralEmail from '../Marketing/GeneralEmail';
import UserVerificationTable from './UserVerificationTable';
import IndustryPage from './IndustryPage';
import OrganizationPageAdmin from './OrganizationPageAdmin';
import CreateAreaOfInterest from './CreateAreaOfInterest';
import UserVerificationList from './UserVerificationList';
import CompletedSessions from './CompletedSessions';
import AdminCreateAccounts from './AdminCreateAccounts';
import AdminCreate_coupon from './AdminCreateCoupon';
import AdminCreateCoupon from './AdminCreateCoupon';
import AdminQueryBuilder from './AdminQueryBuilder';
import CreateEmployee from './CreateEmployee';
import UserReservationsTable from '../UserReservations/UserReservationsTable';
import ActivePostBookings from '../DataAnalytics/ActivePostBookings';
import { useAuth } from '../../AuthContext';
import SendDiwaliEmailButton from '../Emails/SendDiwaliEmailButton';

const API_URL = process.env.REACT_APP_API_URL;

function AdminPortal({ onLogout }) {

    const { userId } = useAuth();
    const { role, roles } = useAuth();
const userRoles = Array.isArray(roles) && roles.length > 0 ? roles : [role];

    const { loggedIn } = useAuth()
    const { logout } = useAuth();

    useEffect(() => {
        window.scrollTo(0, 0);  // Scroll to top when this page is loaded
    }, []);

    const [activePage, setActivePage] = useState(null);
    // const [password, setPassword] = useState('');  // State for entered password
    const [isAuthenticated, setIsAuthenticated] = useState(false);  // To check if the user is authenticated
    const navigate = useNavigate();



    // const correctPassword = 'Watch@26012024'; // Store the correct password here (for demo purposes, store it in code)

    const handlePageChange = (page) => {
        setActivePage(page);
    };

    // const handlePasswordChange = (e) => {
    //     setPassword(e.target.value);
    // };

    // const handleSubmitPassword = () => {
    //     if (password === correctPassword) {
    //         setIsAuthenticated(true); // Allow access to admin page if password is correct
    //     } else {
    //         alert('Incorrect password!'); // Show an alert for incorrect password
    //     }
    // };

    

    const renderContent = () => {
        switch (activePage) {
            case 'create-account-by-admin':
                return <AdminCreateAccounts userId={userId} onLogout={onLogout} />;
            case 'create-subscriptions':
                return <CreateSubscriptions userId={userId} onLogout={onLogout} />;
            case 'completed-sessions':
                return <CompletedSessions userId={userId} onLogout={onLogout} />;
            case 'user-verification-list':
                return <UserVerificationList userId={userId} onLogout={onLogout} />;
            case 'create-coupon-code':
                return <AdminCreateCoupon userId={userId} onLogout={onLogout} />;
            case 'admin-query-builder':
                return <AdminQueryBuilder userId={userId} onLogout={onLogout} />;
            case 'create-area-of-interest':
                return <CreateAreaOfInterest userId={userId} onLogout={onLogout} />;
            case 'general-email':
                return <GeneralEmail userId={userId} onLogout={onLogout} />;
            case 'industry-type':
                return <IndustryPage userId={userId} onLogout={onLogout} />;
            case 'organization-page-admin':
                return <OrganizationPageAdmin userId={userId} onLogout={onLogout} />;
            case 'create-sections':
                return <CreateSections userId={userId} onLogout={onLogout} />;
            case 'create-specialized-fields-roles':
                return <CreateSpecializedFields userId={userId} onLogout={onLogout} />;
            case 'add-sub-sections':
                return <AddSubSections userId={userId} onLogout={onLogout} />;
            case 'user-section-verification':
                return <AdminVerification userId={userId} onLogout={onLogout} />;
            case 'update-subscription':
                return <UpdateSubscription userId={userId} onLogout={onLogout} />;
            case 'delete-subscription':
                return <DeleteSubscription userId={userId} onLogout={onLogout} />;
            case 'create-language':
                return <CreateLanguage userId={userId} onLogout={onLogout} />;
            case 'update-posts':
                return <AdminUpdatePosts userId={userId} onLogout={onLogout} />;
            case 'delete-language':
                return <DeleteLanguage userId={userId} onLogout={onLogout} />;
            case 'update-sections':
                return <UpdateSections userId={userId} onLogout={onLogout} />;
            case 'delete-section':
                return <DeleteSection userId={userId} onLogout={onLogout} />;
            default:
                return (
                    <Typography variant="h6" sx={{ mt: 4, textAlign: 'center', color: '#555' }}>
                        Select an option to get started.
                    </Typography>
                );
        }
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    

    return (
        <div>
            <Header1 />
            <Box
                sx={{
                    bgcolor: '#1111',
                    minHeight: '100vh',
                    mt: 10,
                    py: 5,
                    px: { xs: 2, sm: 10 },
                }}
            >
                {/* Header */}
                <Typography
                    variant="h4"
                    component="h1"
                    sx={{
                        fontWeight: 'bold',
                        mb: 4,
                        textAlign: 'center',
                        color: 'white'
                    }}
                >
                    Admin Portal
                </Typography>

                {/* Navigation Options */}
                <Grid container spacing={4} justifyContent="center">

                    {['admin', 'anthra-sales-executive'].some(r => userRoles.includes(r)) && (

                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Post Review Dashboard
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/post-review-panel')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin'].some(r => userRoles.includes(r)) && (

                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Send Diwali Emails
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/send-diwali-email-button')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    
                     <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Active Sessions 
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/active-posts')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    {['admin', 'anthra-sales-executive'].some(r => userRoles.includes(r)) && (
                     <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Admin Create Accounts
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/admin-create-accounts')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}
                      {['admin', 'anthra-sales-executive'].some(r => userRoles.includes(r)) && (
                     <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Create Member
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/create-member')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}


                      {['admin', 'anthra-sales-executive'].some(r => userRoles.includes(r)) && (
                     <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                User Reservations
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/user-reservations')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                     <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Experts Management
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/admin-expert-requests')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Ambassadors Management
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/admin-ambassador-requests')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Sales Partners Management
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/admin-sales-partner-dashboard')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>


                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Active Post Bookings
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/active-post-bookings')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    


                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Create Subscriptions
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('create-subscriptions')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}
                    
                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Completed Sessions
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('completed-sessions')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                User Verification List
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('user-verification-list')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin', 'anthra-sales-executive'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Create Coupon Code
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('create-coupon-code')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {/* <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Query Builder
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('admin-query-builder')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid> */}


                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Create Areas of Interests
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('create-area-of-interest')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                General Email
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('general-email')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Industry Type
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('industry-type')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Organization Approvals
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('organization-page-admin')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Create Specialized Fields and Roles
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('create-specialized-fields-roles')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Add Subsections
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('add-sub-sections')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Create Sections
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('create-sections')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                User Sections Verification
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('user-section-verification')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Update Subscription
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('update-subscription')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Delete Subscription
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('delete-subscription')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}


                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Create Languages
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('create-language')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Delete Languages
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('delete-language')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Update Sections
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('update-sections')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Delete section
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('delete-section')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}


                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Reported Posts
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/reported-posts')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                View All Users
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/user-list-view')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>


                    {/* <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Update Subsections
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => handlePageChange('update-subsections')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid> */}

                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Customer Queries
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/Customer-queries-resolve')} // Navigate to customer queries page
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    
                    {/* <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Interview Panel
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/interviw-panel')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid> */}

                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                View FAQS
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/admin-faqs')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>


                    {['admin','anthra-sales-executive'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                View Careers
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/admin-careers')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                View Contact Us
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/admin-contact-us')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                User Payments
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/user-payments')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                update Accounts
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/admin-update-accounts')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                View Users
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/admin-view-user')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}


                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                update Posts
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate('/admin-update-posts')}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                update Requests
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate(`/admin-update-requests/${userId}`)}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Data Analytics
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate(`/data-analytics`)}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}

                    {['admin'].some(r => userRoles.includes(r)) && (
                    <Grid item xs={12} sm={6} md={4}>
                        <Paper
                            elevation={3}
                            sx={{
                                p: 3,
                                textAlign: 'center',
                                borderRadius: 2,
                                backgroundColor: '#1111',
                                transition: 'transform 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                    transform: 'scale(1.05)',
                                    boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                                },
                            }}
                        >
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: 2,
                                    color: '#1E90FF',
                                    fontWeight: 'bold',
                                }}
                            >
                                Database Size Display
                            </Typography>
                            <Button
                                variant="contained"
                                onClick={() => navigate(`/database-size-display`)}
                                sx={{
                                    bgcolor: '#1E90FF',
                                    '&:hover': {
                                        bgcolor: '#0066cc',
                                    },
                                }}
                            >
                                Open
                            </Button>
                        </Paper>
                    </Grid>
                    )}
                </Grid>


                {/* Dynamic Content Area */}
                <Box
                    sx={{
                        mt: 6,
                        p: 4,
                        backgroundColor: '#1111',
                        borderRadius: 2,
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    {renderContent()}
                </Box>

            </Box>

            <Footer2 />
        </div>
    );
}

export default AdminPortal;
